(() => {
  if (typeof window.SwatchTooltip !== 'undefined') {
    return;
  }

  class SwatchTooltip {
    constructor() {
      this.init();
    }

    init() {
      // Check if swatches exist
      const swatches = document.querySelectorAll('.swatch[data-swatch-tooltip]');
      
      if (swatches.length > 0) {
        this.bindEvents();
      }
    }

    bindEvents() {
      // Simple hover events directly on swatches
      const swatches = document.querySelectorAll('.swatch[data-swatch-tooltip]');
      
             swatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', () => {
          this.showTooltip(swatch);
        });
        
        swatch.addEventListener('mouseleave', () => {
          this.hideTooltip(swatch);
        });
      });
    }

    showTooltip(swatch) {
      const tooltip = swatch.querySelector('.swatch-tooltip');
      if (!tooltip) return;

      // Check if tooltip would be cut off at the top of the viewport
      const swatchRect = swatch.getBoundingClientRect();
      const tooltipHeight = 40; // Approximate tooltip height
      const buffer = 10;

      if (swatchRect.top < tooltipHeight + buffer) {
        tooltip.classList.add('swatch-tooltip--bottom');
      } else {
        tooltip.classList.remove('swatch-tooltip--bottom');
      }

      tooltip.classList.add('swatch-tooltip--active');
    }

    hideTooltip(swatch) {
      const tooltip = swatch.querySelector('.swatch-tooltip');
      if (!tooltip) return;

      tooltip.classList.remove('swatch-tooltip--active');
    }
  }

  // Initialize when DOM is ready
  function initTooltips() {
    window.SwatchTooltip = new SwatchTooltip();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTooltips);
  } else {
    initTooltips();
  }
})(); 